export default {
  banners: `/v1/settings/banners`,
  available_banners: `/v1/settings/available_banners`,
  banner: (id: string) => `/v1/settings/banners/${id}`
};
